import { AxiosError } from "axios";

import { getAccessToken, getCustomerId } from "@/helpers/auth-helpers";
import { getPartnerToken } from "./get-partner-token";
import { gupshupIntegrationService } from "@/api/customer-platform/whatsapp/gupshup-integration";
import { apiT2B } from "@/lib/axios";

export async function unsubscribeGupshup(
  appId: string,
  customerPlatformId: number
): Promise<void> {
  try {
    const partnerToken = await getPartnerToken();
    const accessToken = getAccessToken();
    const customerId = getCustomerId();

    if (!accessToken || !customerId) {
      throw new Error("Missing authentication data");
    }

    const subscription = await gupshupIntegrationService.getAppSubscription(appId, partnerToken);

    if (subscription && subscription.id) {
      await gupshupIntegrationService.deleteSubscription(appId, subscription.id, partnerToken);
    }

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        CustomerId: customerId,
      },
    };

    await apiT2B.delete(`api/v1/customerplatform/${customerPlatformId}`, config);
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(
        `Failed to unsubscribe: ${error.response?.data?.message || error.message}`
      );
    }
    throw error;
  }
}

